import images from './images';

const wines = [
  {
    title: 'Presheaf Chardonnay',
    price: '$56',
    tags: 'AU | Bottle',
  },
  {
    title: 'Adjoint Functor Malbec',
    price: '$59',
    tags: 'AU | Bottle',
  },
  {
    title: 'Isomorphism Rose',
    price: '$44',
    tags: 'FR | 750 ml',
  },
  {
    title: 'Holomorphic Ale',
    price: '$31',
    tags: 'CA | 750 ml',
  },
  {
    title: 'Abelian Guinness',
    price: '$26',
    tags: 'IE | 750 ml',
  },
];

const cocktails = [
  {
    title: 'Topological Spritz',
    price: '$20',
    tags: 'Aperol | Villa Marchesi prosecco | soda | 30 ml',
  },
  {
    title: "Moduli Stack Mojito",
    price: '$16',
    tags: 'Dark rum | Ginger beer | Slice of lime',
  },
  {
    title: 'Manifold Daiquiri',
    price: '$10',
    tags: 'Rum | Citrus juice | Sugar',
  },
  {
    title: 'Ring Homomorhism Martini',
    price: '$31',
    tags: 'Bourbon | Brown sugar | Angostura Bitters',
  },
  {
    title: 'Cobordism Negroni',
    price: '$26',
    tags: 'Gin | Sweet Vermouth | Campari | Orange garnish',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'Bib Gourmond',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'AA Hospitality',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Chef',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

const navLinks = [
  { title: 'Home', href: '#home' },
  { title: 'Menu', href: '#menu' },
  { title: 'Awards', href: '#awards' },
  { title: 'Contact', href: '#contact' }, 
]

const data = { wines, cocktails, awards, navLinks };

export default data;
